module.exports = __webpack_public_path__ + "assets/img/d35b-bt.svg";